import { FC } from 'react'
import { getDateTimeString } from 'lib/helpers/dateHelper'

interface MintWindowProps {
  startDate: Date | null
  endDate: Date | null
}

const MintWindow: FC<MintWindowProps> = ({ startDate, endDate }) => {
  if (!startDate || !endDate) return null

  return (
    <p>
      <strong>Mint window:</strong> {getDateTimeString(new Date(startDate))} - {getDateTimeString(new Date(endDate))}
    </p>
  )
}

export default MintWindow
